module.exports = "/assets/site/images/mvm_se_logo.png?0573b4f7a55bf284bdd88b3c09e9c0d0";